import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HandleType, ServiceHandle } from 'src/app/db/models/service-handle';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { HandlesService } from 'src/app/services/handles.service';

@Component({
  selector: 'app-handle-action',
  templateUrl: './handle-action.component.html',
  styleUrls: ['./handle-action.component.scss']
})
export class HandleActionComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title  = 'Social Media Links';
  subtitle = '';

  haform: FormGroup;

  handle = new ServiceHandle();
  private sub: Subscription;
  user: User;
  serviceId: string;
  loading = false;

  handleTypes: HandleType[];

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
              private router: Router,
              private route: ActivatedRoute,
              private service: HandlesService,
              private spinner: NgxSpinnerService,
              private authenticate:AuthenticationService,
              private notify: ToastrService)
  {
    this.validationMessages = {
      handleDetail: {
        required: 'Copy Link from selected handle app and paste here'
      },
      handleTypeId: {
        required: 'Select one'
      }
    }

    this.genericValidator = new GenericValidator(this.validationMessages);
    this.authenticate.currentUser.subscribe(x => this.user = x);
  }

  ngOnInit() {

    //on Page Initialize get me the id parameter from the route
    this.sub = this.route.paramMap.subscribe(
      params => {
        const id = params.get('id');
        this.serviceId = id;
      }
    )

    this.createFrom();
    this.getHandleTypes();

  }

  createFrom() {
    this.haform = this.fb.group({
      handleDetail: [null, Validators.required],
      handleTypeId: [null, Validators.required]
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.haform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.haform);
    });
  }

  getHandleTypes(){
    this.service.getAllHandleTypes().subscribe(
      data => {
        this.handleTypes = data;
      }
    )
  }

  get handleDetail() {
    return this.haform.controls.handleDetail as FormControl;
  }

  get handleTypeId() {
    return this.haform.controls.handleTypeId as FormControl;
  }

  mapEntity(): void {
    this.handle.handleDetail = this.handleDetail.value;
    this.handle.handleTypeId = this.handleTypeId.value;
    this.handle.serviceId = this.user.serviceId;
  }

  saveData(){
    this.loading = true;
    if (this.haform.valid) {
        this.mapEntity();
        // console.log(this.handle);
        this.service.addServiceHandle(this.handle)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.successNotification();
          },
          error: err => {
            this.spinner.hide();
            this.errorNotification();
          }
        })
    } else {

    }
  }

  successNotification(){
    this.notify.success('Service Handle added');
    this.router.navigate([`/profile/${this.user.id}`])
  }

  errorNotification(){
    this.notify.warning('Cannot add Handle');
    this.router.navigate([`/profile/${this.user.id}`])
  }

}

